// extracted by mini-css-extract-plugin
module.exports = {"feedbackButton":"FeedbackModal_feedbackButton__d-rPY","feedbackModal":"FeedbackModal_feedbackModal__2WoZH","feedbackRating":"FeedbackModal_feedbackRating__1Gk5G"};